<template>
  <a-modal
    :title='title'
    :width='1200'
    :visible='visible'
    :maskClosable='false'
    :confirmLoading='confirmLoading'
    @ok='handleOk'
    @cancel='handleCancel'
  >
    <a-spin :spinning='confirmLoading'>
      <!-- 主表单区域 -->
      <a-form :form='form'>
        <a-row>
          <a-col :span='12'>
            <a-form-item label='配置id' :labelCol='labelCol' :wrapperCol='wrapperCol'>
              <a-input
                v-decorator="['setId', validatorRules.setId]"
                placeholder='请输入配置id'
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span='12'>
            <a-form-item label='配置名称' :labelCol='labelCol' :wrapperCol='wrapperCol'>
              <a-input v-decorator="['setName', validatorRules.setName]" placeholder='请输入配置名称'></a-input>
            </a-form-item>
          </a-col>
          <a-col :span='12'>
            <a-form-item label='源头数据库' :labelCol='labelCol' :wrapperCol='wrapperCol'>
              <j-dict-select-tag
                type='list'
                v-decorator="['sourceCode', validatorRules.sourceCode]"
                :trigger-change='true'
                dictCode='bus_data_sync_data_source,name,code'
                placeholder='请选择源头数据库'
              />
            </a-form-item>
          </a-col>
          <a-col :span='12'>
            <a-form-item label='目标数据库' :labelCol='labelCol' :wrapperCol='wrapperCol'>
              <j-dict-select-tag
                type='list'
                v-decorator="['targetCode', validatorRules.targetCode]"
                :trigger-change='true'
                dictCode='bus_data_sync_data_source,name,code'
                placeholder='请选择目标数据库'
              />
            </a-form-item>
          </a-col>
          <a-col :span='12'>
            <a-form-item label='源头业务表' :labelCol='labelCol' :wrapperCol='wrapperCol'>
              <a-input
                v-decorator="['dataTable', validatorRules.dataTable]"
                placeholder='请输入源头业务表'
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span='12'>
            <a-form-item label='目标业务表' :labelCol='labelCol' :wrapperCol='wrapperCol'>
              <a-input
                v-decorator="['targetTable', validatorRules.targetTable]"
                placeholder='请输入目标业务表'
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span='12'>
            <a-form-item label='源头业务表主键' :labelCol='labelCol' :wrapperCol='wrapperCol'>
              <a-input
                v-decorator="['dataKey', validatorRules.dataKey]"
                placeholder='请输入源头业务表主键'
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span='12'>
            <a-form-item label='目标业务表主键' :labelCol='labelCol' :wrapperCol='wrapperCol'>
              <a-input
                v-decorator="['targetKey', validatorRules.targetKey]"
                placeholder='请输入目标业务表主键'
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span='12'>
            <a-form-item label='源头业务表字段' :labelCol='labelCol' :wrapperCol='wrapperCol'>
              <a-input
                v-decorator="['dataField', validatorRules.dataField]"
                placeholder='请输入源头业务表字段'
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span='12'>
            <a-form-item label='目标业务表字段' :labelCol='labelCol' :wrapperCol='wrapperCol'>
              <a-input
                v-decorator="['targetField', validatorRules.targetField]"
                placeholder='请输入目标业务表字段'
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span='12'>
            <a-form-item label='导入formid' :labelCol='labelCol' :wrapperCol='wrapperCol'>
              <a-input v-decorator="['impFormid', validatorRules.impFormid]" placeholder='请输入导入formid'></a-input>
            </a-form-item>
          </a-col>
          <a-col :span='12'>
            <a-form-item label='执行存储过程' :labelCol='labelCol' :wrapperCol='wrapperCol'>
              <a-input
                v-decorator="['dataProcedure', validatorRules.dataProcedure]"
                placeholder='请输入执行存储过程'
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span='12'>
            <a-form-item label='导入的状态' :labelCol='labelCol' :wrapperCol='wrapperCol'>
              <a-input-number
                v-decorator="['impStatus', validatorRules.impStatus]"
                placeholder='请输入导入的状态'
                style='width: 100%'
              />
            </a-form-item>
          </a-col>
          <a-col :span='12'>
            <a-form-item label='导出后的状态' :labelCol='labelCol' :wrapperCol='wrapperCol'>
              <a-input-number
                v-decorator="['expStatus', validatorRules.expStatus]"
                placeholder='请输入导出后的状态'
                style='width: 100%'
              />
            </a-form-item>
          </a-col>
          <a-col :span='12'>
            <a-form-item label='备注' :labelCol='labelCol' :wrapperCol='wrapperCol'>
              <a-input v-decorator="['remarks', validatorRules.remarks]" placeholder='请输入备注'></a-input>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>

import { httpAction } from '@/api/manage'
import pick from 'lodash.pick'
import JDictSelectTag from '@/components/dict/JDictSelectTag'

export default {
  name: "BusDataSyncUopDocMainSetModal",
  components: {
    JDictSelectTag
  },
  data () {
    return {
      form: this.$form.createForm(this),
      title:"操作",
      width:800,
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      validatorRules: {
        setId: { rules: [{ required: true, message: '请输入配置id!' }] },
        setName: { rules: [{ required: true, message: '请输入配置名称!' }] },
        sourceCode: { rules: [{ required: true, message: '请选择源头数据库!' }] },
        targetCode: { rules: [{ required: true, message: '请选择目标数据库!' }] },
        dataTable: { rules: [{ required: true, message: '请输入源头业务表!' }] },
        dataKey: { rules: [{ required: true, message: '请输入源头业务表主键!' }] },
        dataField: { rules: [{ required: true, message: '请输入源头业务表字段!' }] },
        targetTable: { rules: [{ required: true, message: '请输入目标业务表!' }] },
        targetField: { rules: [{ required: true, message: '请输入目标业务表字段!' }] },
        targetKey: { rules: [{ required: true, message: '请输入目标业务表主键!' }] },
        remarks: { rules: [] },
        impFormid: { rules: [] },
        impStatus: { rules: [] },
        expStatus: { rules: [] }
      },
      url: {
        add: '/uopdoc/busDataSyncUopDocMainSet/add',
        edit: '/uopdoc/busDataSyncUopDocMainSet/edit'
      }
    }
  },
  computed: {
    ifEdit() {
      return !!this.model.id
    },
  },
  created () {
  },
  methods: {
    add () {
      this.edit({});
    },
    edit (record) {
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.model,
          'setId',
          'setName',
          'sourceCode',
          'targetCode',
          'dataTable',
          'dataKey',
          'dataField',
          'dataProcedure',
          'targetTable',
          'targetField',
          'targetKey',
          'remarks',
          'impFormid',
          'impStatus',
          'expStatus'))
      })
    },
    close () {
      this.$emit('close');
      this.visible = false;
    },
    handleOk () {
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          let httpurl = '';
          let method = '';
          if(!this.model.id){
            httpurl+=this.url.add;
            method = 'post';
          }else{
            httpurl+=this.url.edit;
            method = 'put';
          }
          let formData = Object.assign(this.model, values);
          console.log("表单提交数据",formData)
          httpAction(httpurl,formData,method).then((res)=>{
            if(res.success){
              that.$message.success(res.message);
              that.$emit('ok');
              that.close();
            }else{
              that.$message.warning(res.message);
            }
          }).finally(() => {
            that.confirmLoading = false;
          })
        }

      })
    },
    handleCancel () {
      this.close()
    },
    popupCallback(row) {
      this.form.setFieldsValue(
        pick(
          row,
          'setId',
          'setName',
          'sourceCode',
          'targetCode',
          'dataTable',
          'dataKey',
          'dataField',
          'dataProcedure',
          'targetTable',
          'targetField',
          'targetKey',
          'remarks',
          'impFormid',
          'impStatus',
          'expStatus'
        )
      )
    },
  }
}
</script>

<style scoped></style>
<style lang="less" scoped>
.ant-form-item{
  margin-bottom: 10px !important;
}
</style>